import HelpIcon from '@mui/icons-material/Help';
import ReactTooltip from 'react-tooltip';

export const timeOfInitAttendanceHeader = () => (
  <>
    Tempo de início de atendimento
    <HelpIcon
      style={{ 'color': '#a1a5ab', marginTop: -7 }}
      fontSize="small"
      data-for="proportion-info"
      data-place="bottom"
      data-tip='Esta coluna corresponde ao tempo médio decorrido do início da ocorrência até o estado "Em análise"'
    />
    <ReactTooltip id="proportion-info" className='popup' />
  </>
)

export const timeOfFinishAttendanceHeader = () => (
  <>
    Tempo de resolução de ocorrência
    <HelpIcon
      style={{ 'color': '#a1a5ab', marginTop: -7 }}
      fontSize="small"
      data-for="proportion-info"
      data-place="bottom"
      data-tip='Esta coluna corresponde ao tempo médio decorrido do início da ocorrência até sua solução'
    />

    <ReactTooltip id="proportion-info" className='popup' />
  </>
)